// extracted by mini-css-extract-plugin
export default {"bimabossDatePicker":"BimabossDatePicker_bimabossDatePicker__gfsbO"};